import { temAcesso } from '@/shared/auth/temAcesso'

const Pagamentos = () => import('./Pagamentos.vue')
const Pagamento = () => import('./Pagamento.vue')
const PagamentoAssociarComprometimentos = () =>
    import('./PagamentoAssociarComprometimentos.vue')

export default {
    path: 'contratos-pagamentos',
    name: 'FornecedorContratos_Pagamentos',
    component: Pagamentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-FORN-PAG-00')) {
            next()
        }
    },
    children: [
        {
            path: ':pagamentoId',
            name: 'FornecedorContratos_Pagamentos_Detalhar',
            component: Pagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-FORN-PAG-02')) {
                    next()
                }
            },
            children: [
                {
                    path: 'associaratividades',
                    name:
                        'FornecedorContratos_Pagamentos_AssociarComprometimentos',
                    component: PagamentoAssociarComprometimentos,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('GESCON-FORN-PAG-03')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
